import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { signIn } from "../../store/actions/AuthActions";
import { Link, Redirect } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";
import { BsEnvelope, BsLock } from "react-icons/bs";
import Logo from "../../components/Logo";

function Login() {
  const style = {
    loginBtn:
      "w-full bg-indigo-500 text-white px-4 py-3 rounded hover:bg-indigo-600 font-medium text-xs flex flex-row",
    field: {
      parentDiv:
        "border border-indigo-200 focus-within:bg-indigo-50  py-3 px-3 rounded flex flex-row  focus-within:border-indigo-500",
      input: "h-full w-4/5 focus:outline-none bg-transparent",
      icon: "m-auto ml-0 mr-1 hidden",
    },
    descParagraph:
      "flex bg-indigo-50 xl:w-32 lg:w-32 md:w-32 w-auto border border-indigo-50 text-gray-500 m-auto xl:mx-4 mx-2 py-2 px-4 rounded  font-normal  text-xs flex flex-row",
  };

  const loaders = useSelector((state) => state.loadersState);

  const [creds, setCreds] = useState({
    username: "",
    password: "",
  });

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth.session);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(signIn(creds));
  };

  if (auth) return <Redirect to="/workspaces" />;
  return (
    <AuthLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="flex flex-col text-white m-auto min-h-full w-full">
        <Link className="py-3 m-auto mb-2 text-white" to="/">
          <Logo />
        </Link>
        {/* Login form */}
        <div className="bg-white flex flex-col rounded  pt-0 text-gray-500 xl:w-96 lg:w-96 md:w-96 m-auto mt-2 w-full">
          <div
            className={
              loaders.loginFailedMessage
                ? "bg-red-200 text-xs rounded text-center py-2 text-red-500 font-semibold"
                : "hidden"
            }
          >
            <p>{loaders.loginFailedMessage}</p>
          </div>
          <div className="p-8 py-5">
            <h2 className="font-medium text-md py-2 pt-5">Welcome</h2>
            <div className="text-xs">
              <p className="text-gray-600 font-medium">
                Sign in to continue to your account
              </p>

              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="py-2">
                  <label>Username </label>
                  <div className={style.field.parentDiv}>
                    <BsEnvelope className={style.field.icon} />
                    <input
                      type="text"
                      placeholder="Enter your username"
                      className={style.field.input}
                      value={creds.username}
                      onChange={(e) => {
                        setCreds({
                          ...creds,
                          username: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="py-2">
                  <label>Password </label>
                  <div className={style.field.parentDiv}>
                    <BsLock className={style.field.icon} />
                    <input
                      type="password"
                      placeholder="Enter your password"
                      className={style.field.input}
                      value={creds.password}
                      onChange={(e) => {
                        setCreds({
                          ...creds,
                          password: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="py-1">
                  <Link to="/resetlink" className="text-indigo-600">
                    Forgot password
                  </Link>
                </div>

                <button
                  type="submit"
                  className={style.loginBtn}
                  disabled={loaders.loginLoader}
                >
                  {!loaders.loginLoader ? (
                    <p className="m-auto">Log in</p>
                  ) : (
                    <div class="spinner m-auto">
                      <div class="bounce1"></div>
                      <div class="bounce2"></div>
                      <div class="bounce3"></div>
                    </div>
                  )}
                </button>
              </form>
              <div className="py-1 flex">
                Don't have account?
                <Link to="#" className="text-indigo-600">
                  Call 078627388000
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </AuthLayout>
  );
}

export default Login;
